import axios, { AxiosError, AxiosResponse }                     from 'axios';
import qs                                                       from 'qs';
import { useInfiniteQuery, useMutation }                        from 'react-query';
import { queryClient }                                          from '../../../../../App';
import { IErrorResponse, IPaginatedResponse, IRequestResponse } from '../../../../../Auth/shared/interfaces';
import { Notistack }                                            from '../../../../../shared/components/Notistack/Notistack';
import { EFamilyItemType, ITaggedItem }                         from '../MentionedEntities/shared';

export const TAGGED_ITEMS = 'TAGGED_ITEMS';
export const DELETE_TAGGED_ITEM = 'DELETE_TAGGED_ITEM';

const onCatch = (error: IErrorResponse) => {
  throw error;
};

const loadTaggedItems = (familyUserId: string | undefined, familyItemType: EFamilyItemType, offset: number, limit: number) =>
  axios.get(`/api/v1/family-items/${ familyUserId }?${ qs.stringify({ offset, limit, familyItemType }) }`)
    .then(({ data: { data: { items, totalCount } } }: AxiosResponse<IRequestResponse<IPaginatedResponse<ITaggedItem>>>) => ({
      items,
      totalCount,
      next: offset + limit,
    }))
    .catch(onCatch);

export const useLoadTaggedItemsPage = (familyMemberId: string | undefined, type: EFamilyItemType, limit = 100) => useInfiniteQuery(
  [ TAGGED_ITEMS, familyMemberId, type ],
  ({ pageParam = 0 }) => loadTaggedItems(familyMemberId, type, pageParam, limit),
  {
    enabled          : !!familyMemberId,
    getNextPageParam : (lastPage) => lastPage?.totalCount > lastPage.next && lastPage.next,
  });

export const deleteTaggedItem = (
  id?: string,
) =>
  axios.delete(`/api/v1/family-items/tags/${ id }`)
    .then(({ data: { data } }: AxiosResponse<IRequestResponse<{ message: string }>>) => data)
    .catch((error: IErrorResponse) => {
      throw error;
    });

export const useDeleteTaggedItem = () => useMutation(
  DELETE_TAGGED_ITEM,
  (id: string) => deleteTaggedItem(id),
  {
    onSuccess: data => {
      Notistack.enqueueSnackbar(`${ data?.message }`, 'success');
      queryClient.invalidateQueries([ TAGGED_ITEMS ]);
    },
    onError: (error: AxiosError<IErrorResponse>) => {
      Notistack.enqueueSnackbar(error?.response?.data?.ErrorDetails?.Message, 'error');
    },
  }
);
